<template>
  <div class="step" :class="{ active: organizations.length }">
    <BaseIcon glyph="user" width="32px" class="mb-s" />
    <p class="mb-xs fw-700">Шаг 2</p>
    <p class="step-description">
      Заполнить страничку организации в&nbsp;<a
        :href="kabOrgLink"
        target="_blank"
        rel="noopener noreferrer"
        title="Платформа Талант"
        class="link-text"
        >Кабинете организатора платформы &laquo;Талант&raquo;</a
      >.
    </p>
    <div v-if="user" class="info-block">
      <StepInfo class="mt-s" :is-done="!!organizations.length" />
      <StepInfo
        class="mt-s"
        :info-text="orgsCountText"
        :is-success="!!organizations.length"
      />
      <BaseButton
        tag="a"
        :href="conditionKabOrgLink"
        :target="organizations.length ? '_blank' : '_self'"
        rel="noopener noreferrer"
        class="mt-s"
        size="xs"
        shape="square"
        >{{
          organizations.length ? "Перейти в Каборг" : "Создать организацию"
        }}</BaseButton
      >
    </div>
  </div>
</template>

<script>
import StepInfo from "@/components/StepInfo";
import { numCases } from "@/utils";
export default {
  name: "OrganizationStep",
  components: {
    StepInfo,
  },

  computed: {
    organizations() {
      return this.$store.state.requestPreparing.organizations;
    },
    user() {
      return this.$store.state.user.user;
    },
    kabOrgLink() {
      return process.env.VUE_APP_TALENT_HOST + "/org";
    },
    conditionKabOrgLink() {
      const { organizations } = this;
      if (organizations.length) {
        return this.kabOrgLink;
      }
      return `${
        process.env.VUE_APP_TALENT_HOST
      }/org/organizations/create?redirect_uri=${encodeURIComponent(
        window.location.href
      )}`;
    },
    orgsCountText() {
      const { organizations } = this;
      if (!organizations.length) {
        return "У вас нет кружков";
      }

      return `У вас ${organizations.length} ${numCases(
        ["организация", "организации", "организаций"],
        organizations.length
      )}`;
    },
  },
};
</script>

<style lang="less" scoped>
.step {
  padding: 20px;
  width: 100%;
  border-radius: @border-radius-xs;
  border: 1px solid @blue-color;
  background-color: #fff;
  color: @primary-color;
  display: flex;
  flex-direction: column;

  &-description {
    color: @base-color;
  }

  &.active {
    background-color: @background-blue;
    border-color: @info-color;
    color: @base-color;
  }
}

.info-block {
  margin-top: auto;
}

@media (max-width: @screen-xs-max) {
  .step {
    max-width: 100%;
  }
}
</style>
